/**
 * @generated SignedSource<<611bfdab8975eb13dd8d39e66803704b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StoredObjectType = "ALL" | "CURRICULUM_ALIGNMENT_DOCUMENTS" | "PRACTICE_PROBLEMS" | "WORKED_EXAMPLE_VIDEO" | "%future added value";
export type PresignedUrlsForSkillFilterInput = {
  storedObjectType: StoredObjectType;
};
export type SkillsPresignedURLsQuery$variables = {
  filter: PresignedUrlsForSkillFilterInput;
  skillCode: string;
};
export type SkillsPresignedURLsQuery$data = {
  readonly presignedURLsForSkill: {
    readonly illustrativeMathAlignmentUrl: string | null | undefined;
    readonly practiceProblemsUrl: string | null | undefined;
    readonly revealMathAlignmentUrl: string | null | undefined;
    readonly workedExampleVideoEnglishCaptionUrl: string | null | undefined;
    readonly workedExampleVideoSpanishCaptionUrl: string | null | undefined;
    readonly workedExampleVideoUrl: string | null | undefined;
  };
};
export type SkillsPresignedURLsQuery = {
  response: SkillsPresignedURLsQuery$data;
  variables: SkillsPresignedURLsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillCode"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "skillCode",
        "variableName": "skillCode"
      }
    ],
    "concreteType": "SkillPresignedUrls",
    "kind": "LinkedField",
    "name": "presignedURLsForSkill",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workedExampleVideoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "practiceProblemsUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "revealMathAlignmentUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "illustrativeMathAlignmentUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workedExampleVideoEnglishCaptionUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workedExampleVideoSpanishCaptionUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsPresignedURLsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SkillsPresignedURLsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "32d1155e126f198791303c7ba0bf38f5",
    "id": null,
    "metadata": {},
    "name": "SkillsPresignedURLsQuery",
    "operationKind": "query",
    "text": "query SkillsPresignedURLsQuery(\n  $skillCode: String!\n  $filter: PresignedUrlsForSkillFilterInput!\n) {\n  presignedURLsForSkill(skillCode: $skillCode, filter: $filter) {\n    workedExampleVideoUrl\n    practiceProblemsUrl\n    revealMathAlignmentUrl\n    illustrativeMathAlignmentUrl\n    workedExampleVideoEnglishCaptionUrl\n    workedExampleVideoSpanishCaptionUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "d29b1b50a714a269204782a505cddf1b";

export default node;
